import { Redirect, Route, Switch } from "react-router-dom";
import React from "react";
import { DataExplorationPageV2 } from "pages/DataExplorationPageV2";

export const DataExplorationRoutesV2 = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path="/pages/data-exploration">
        <DataExplorationPageV2 />
      </Route>

      {/* Redirect to the closest exact path above when an incorrect url is entered*/}
      <Redirect to="/pages/data-exploration" from="/pages/data-exploration" />

      <Redirect to="/pages" />
    </Switch>
  );
};
